import { render, staticRenderFns } from "./UiTabItem.vue?vue&type=template&id=e12e73e6&"
import script from "./UiTabItem.vue?vue&type=script&lang=js&"
export * from "./UiTabItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports